'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reduxForm = require('redux-form');
var _reactSelect = require('react-select');var _reactSelect2 = _interopRequireDefault(_reactSelect);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _CommodityInput = require('./CommodityInput');var _CommodityInput2 = _interopRequireDefault(_CommodityInput);
var _constants = require('./constants');

var _PublishNewHomesForm = require('./PublishNewHomesForm.scss');var _PublishNewHomesForm2 = _interopRequireDefault(_PublishNewHomesForm);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _objectWithoutProperties(obj, keys) {var target = {};for (var i in obj) {if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];}return target;}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

CommodityBlock = function (_Component) {_inherits(CommodityBlock, _Component);
  function CommodityBlock(props) {_classCallCheck(this, CommodityBlock);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_initialiseProps.call(_this);
    var showInput = props.value && props.value.length ?
    !Object.values(_constants.commodityOptionTypes).includes(props.value) :
    false;

    _this.state = {
      showInput: showInput };return _this;

  }CommodityBlock.prototype.

  componentWillReceiveProps = function componentWillReceiveProps(newProps) {
    if (this.props.value !== newProps.value && newProps.value === 'other') {
      this.setState({ showInput: true });
      this.props.onSelect({ value: '' });
    }
  };CommodityBlock.prototype.

















  render = function render() {var _cx;var _props =














    this.props,children = _props.children,onSelect = _props.onSelect,onClick = _props.onClick,value = _props.value,options = _props.options,translate = _props.translate,name = _props.name,canAddCommodity = _props.canAddCommodity,isRtl = _props.isRtl,hasError = _props.hasError,error = _props.error,index = _props.index,onRemove = _props.onRemove;

    return (
      _react2.default.createElement('div', { className: _PublishNewHomesForm2.default.extrasBlock },
        _react2.default.createElement('div', { className: _PublishNewHomesForm2.default.advantageWrapper },
          _react2.default.createElement('p', null, translate('addNewProject', 'commodity') + ' ' + (index + 1)),
          _react2.default.createElement('button', { type: 'button', onClick: onRemove, className: _PublishNewHomesForm2.default.deleteButton },
            translate('addNewProject', 'delete'))),


        this.state.showInput ?
        _react2.default.createElement(_reduxForm.Field, {
          name: name + '.type',
          type: 'text',
          component: this.renderField }) :

        _react2.default.createElement(_reactSelect2.default, {
          value: value,
          options: options,
          onChange: onSelect,
          searchable: false,
          clearable: false,
          instanceId: 'commodities',
          placeholder: translate('addNewProject', 'commoditiesSelectPlaceholder'),
          className: (0, _classnames2.default)(_PublishNewHomesForm2.default.extrasSelect, (_cx = {}, _cx[
          _PublishNewHomesForm2.default.hasError] = hasError && error === 'required', _cx)),

          isRtl: isRtl }),


        children,
        canAddCommodity &&
        _react2.default.createElement(_reduxForm.Field, {
          name: name,
          component: _CommodityInput2.default,
          canAddCommodity: canAddCommodity,
          translate: translate,
          onClick: onClick,
          hasError: hasError && error === 'atLeastOne' })));




  };return CommodityBlock;}(_react.Component);var _initialiseProps = function _initialiseProps() {var _this2 = this;this.hideInput = function () {_this2.setState({ showInput: false });_this2.props.onSelect({ value: '' });};this.renderField = function (_ref) {var input = _ref.input,_ref$meta = _ref.meta,touched = _ref$meta.touched,error = _ref$meta.error,active = _ref$meta.active,props = _objectWithoutProperties(_ref, ['input', 'meta']);return _react2.default.createElement('div', { className: _PublishNewHomesForm2.default.content }, _react2.default.createElement('label', null, _react2.default.createElement('input', _extends({ className: (0, _classnames2.default)('form-control', { 'has-error': error && !active && touched, touched: touched }, _PublishNewHomesForm2.default.commodityInput) }, input)), touched && error && _react2.default.createElement('span', { className: _PublishNewHomesForm2.default.required }, _this2.props.translate('errorFieldMessages', 'required'))), _react2.default.createElement('div', { className: _PublishNewHomesForm2.default.hideInputIcon, onClick: _this2.hideInput }, _react2.default.createElement('i', { className: 'icon icon-close-property' })));};};exports.default =


CommodityBlock;

CommodityBlock.propTypes = {
  children: _propTypes2.default.node,
  onSelect: _propTypes2.default.func,
  value: _propTypes2.default.string,
  translate: _propTypes2.default.func.isRequired,
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    value: _propTypes2.default.string,
    label: _propTypes2.default.string,
    disabled: _propTypes2.default.bool })),

  isRtl: _propTypes2.default.bool,
  name: _propTypes2.default.string.isRequired,
  canAddCommodity: _propTypes2.default.bool,
  onClick: _propTypes2.default.func.isRequired,
  hasError: _propTypes2.default.bool,
  error: _propTypes2.default.string,
  onRemove: _propTypes2.default.func,
  index: _propTypes2.default.number };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PublishNewHomesForm/CommodityBlock.js
// module id = 3049
// module chunks = 0